export default __webpack_public_path__ + "static/square_w.895d7291081bf3ca440c709cc63d9451.svg";